// extracted by mini-css-extract-plugin
export default {"title":"MultiTierPage_title__RfTLL","multiTierTables":"MultiTierPage_multiTierTables__7iKHp","column":"MultiTierPage_column__NBQST","tabsWrapper":"MultiTierPage_tabsWrapper__aDHC7"};